import { Button, HStack, Heading, Input, Stack, Text, VStack } from '@chakra-ui/react';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { backendurl } from '../path';
import { FaMailBulk, FaMoneyBill, FaPhone } from 'react-icons/fa';

const Teacherinfo = () => {
    const {id}=  useParams();
    const [teacherdata,setdata]=useState(null);
    const [amount,setamount]=useState(null);
    const [month,setmonth]=useState(null);
    const [due,setdue]=useState(null);

    useEffect(() => {
const getteacher=async()=>{
const response = await axios.post(`${backendurl}/get-teacher`,{"_id":id});
setdata(response.data);
console.log(response.data)
}   
getteacher(); 
    }, [id])

const handlepay =async()=>{
    const response = await axios.post(`${backendurl}/pay-salary`,{"_id":id,"amount":amount,"month":month});
    if(response.data.paid)
    {
        window.location.reload();
    }
}

const handledue = async()=>{
    const response = await axios.post(`${backendurl}/insert-due`,{"_id":id,"due":due});
    if(response.data.isInserted)
    {
        window.location.reload();
    }

}
  return (
    <Stack direction={['column','row']} w={'full'} mt={['20vh','25vh']}>
        <VStack  w={'full'}>
            <Heading textTransform={'uppercase'}>{teacherdata?.name}</Heading>
          <HStack>
            <FaMailBulk/>
             <Text>{teacherdata?.email}</Text>
            </HStack> 
            <HStack>
            <FaPhone/>
             <Text>{teacherdata?.contact}</Text>
            </HStack> 

            <HStack>
            <FaMoneyBill/>
             <Text>₹{teacherdata?.salary} per month</Text>
            </HStack> 
            <HStack >
             <Text>Due Salary:</Text>
            <Input fontSize={'xl'} value={teacherdata?.due} readOnly/>
            </HStack>

            <Text fontWeight={'bolder'} mt={'4'}>Salary paid details</Text>
            <VStack overflowY={'scroll'} maxH={'300px'}>
                
                    {teacherdata?.salarypaid?.map((det,ind)=>(
                        <HStack>
                        <Input value={det.amount} readOnly/>
                    <Input value={det.month} type="month" readOnly/>
                </HStack>
                    ))}
                    
                    
            </VStack>
        </VStack>
        <HStack  w='full'>
            <VStack  w="25%" >
        <Input value={due} onChange={(e)=>setdue(e.target.value)} placeholder='Due' type='text' fontSize={'xl'} />
        <Button colorScheme='orange' variant="solid" onClick={handledue}>Save</Button>
            </VStack>
        <VStack w='full'>
<VStack w="60%" bgColor={'#FAF9F6'} rounded={'lg'} p={8}>
<Text fontSize={'2xl'}>Pay salary</Text>
<Input value={teacherdata?.name} fontSize={'xl'} readOnly/>
<Input type="month" placeholder='choose month' value={month} onChange={(e)=>setmonth(e.target.value)} />
<Input value={amount} onChange={(e)=>setamount(e.target.value)} placeholder='enter amount' type='text' fontSize={'xl'} />
<Button px={8} variant={'solid'} colorScheme='orange' onClick={handlepay}>Pay</Button>
</VStack>
        </VStack>
        </HStack>
    </Stack>
  )
}

export default Teacherinfo
